import { render, staticRenderFns } from "./select.vue?vue&type=template&id=0be84eae&scoped=true&lang=pug&"
import script from "./select.vue?vue&type=script&lang=js&"
export * from "./select.vue?vue&type=script&lang=js&"
import style0 from "./select.vue?vue&type=style&index=0&id=0be84eae&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be84eae",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {WidgetsLottie: require('/home/ubuntu/nuxt/bonkers/releases/20230609154748/components/widgets/lottie.vue').default})
